import { Pipe, PipeTransform } from '@angular/core';
import { UserEnvironmentService } from '@y42/environment';
import { formatValueConversion } from '@y42/util/format-value-conversion';
import { isNotNullish } from '@y42/util/nullish';

@Pipe({ name: 'formatValueConversion' })
export class FormatValueConversionPipe implements PipeTransform {
  constructor(private readonly userEnvironmentService: UserEnvironmentService) {}

  transform(labelValue: number | undefined | null, formatBy = '', fraction = 0): string {
    return isNotNullish(labelValue)
      ? formatValueConversion(labelValue, this.userEnvironmentService.locale || 'en', formatBy, fraction)
      : '';
  }
}
